import styled from 'styled-components';

export const TitleResults = styled.h6`
  margin: 0 0 0.4rem 0;
  font-weight: bold;
  color: #000;
`;
export const EndMessage = styled.div`
  color: ${({ theme }) => theme.pantoneBlack};
  font-size: 14px;
  font-weight: bold;
  padding: 10px 0px;
`;

export const AreaSkeleton = styled.div`
	height: 100%;
	width: 100%;
	background-color: white;
	    border: 1px solid #D1D5DB;
    border-radius: 12px;
    padding: 8px;
`;